export default "__VITE_ASSET__cqaDhp0B__"